import React from 'react';
import dynamic from 'next/dynamic';
import styled from 'styled-components';
import resolveConfig from 'tailwindcss/resolveConfig';
import tw from 'twin.macro';

import tailwindConfig from '../../tailwind.config';

const fullConfig = resolveConfig(tailwindConfig);

const CinemaBlock = dynamic(() => import('../cinema-detail'), {
  ssr: false,
});

export const CinemaBlockStyled = styled.div`
  .content-container {
    h2 {
      ${tw`text-white font-bold mb-4`}
      font-size: 32px;
      line-height: 38px;
    }
    h3 {
      ${tw`text-white mb-4`}
      font-size: 28px;
      line-height: 34px;
    }
    p {
      ${tw`mx-8 text-white pb-8`}
    }
    .tech-grid {
      grid-template-columns: 1fr;
      max-width: 1360px;
      ${tw`px-8`}

      @media (min-width: ${fullConfig.theme.screens.md}) {
        grid-template-columns: 306px auto;
      }

      .tech-logo {
        margin: 0 auto;
        @media (min-width: ${fullConfig.theme.screens.md}) {
          margin: 0;
        }
      }

      p {
        ${tw`mx-0`}
      }
    }
  }
`;

const CinemaLobby = (): JSX.Element => {
  return (
    <CinemaBlockStyled className="cinema-lobby">
      <CinemaBlock reverse />
      {/* <div className="content-container">
        <h2>Design &amp; Engineering</h2>
        <p>
          The KCC Multiplex is 100% locally built, run and owned project. It was created on a _____
          sq foot land adjacent to the main mall, a land many deemed unusable and practically
          impossible to build even a single cinema on. A joint effort of local architects, local
          engineers, local contractors and local industry specialists are proud to bring, to the
          city of Kandy, an entertainment venue like no other. The KCC Multiplex was built on the
          principle to be truly local and proudly Sri Lankan. Local building materials, manpower and
          talent was used to the highest potential and imported components were used for very
          specialist equipment that are not locally manufactured. Space was maximized for efficiency
          without a compromise on quality.
        </p>
        <p>
          All cinemas are designed for comfort and applies the best available industry standards to
          bring a unique and enthralling viewing and listening experience. Every step of the way,
          cinemas were designed with the viewer in mind – without cutting corners on the final
          experience delivered. The KCC Multiplex seamlessly blends in to the existing building,
          with roofs and proportions following the traditional Kandyan style, yet makes a modern
          statement with its unique glass façade and grand entrance. Public spaces inside are
          designed with a light theme, capturing as much sunlight as possible and feature double
          height ceilings creating a sense of openness and space. Glass is featured heavily,
          allowing natural light in plenty and an overall sense of clarity. Metallic tones further
          complement the overall building creating a modern, sleek look. Clean lines, curves and
          minimal design are inspired by _____; creating a space modern yet timeless, that’s easy to
          navigate and spacious yet intimate. Public spaces outside follow a similar ethos,
          maximizing space efficiently to provide greater walkability, complemented with greening.
          Through the culmination of the best of both worlds, the finest of local and international,
          the KCC Multiplex houses 3 state-of-the-art cinemas, an events/function hall with
          panoramic views of the Kandy Lake and additional retail spaces.
        </p>
        <h2>Technology &amp; Materials</h2>
        <p>
          All three cinemas feature top-of-the-line international equipment and materials from the
          world’s most coveted manufacturers. All cinema layouts, acoustics, sounds, and visuals are
          designed, engineered, and calibrated entirely by Dolby Labs – meeting all standards and
          protocols.
        </p>
        <div className="tech-grid grid gap-x-6 gap-y-5 md:gap-y-10">
          <div className="tech-logo">
            <img
              src="/assets/images/tech/logo-klipsch-dolby-atmos.png"
              alt="Dolby Atmos - Klipsch"
            />
          </div>
          <div className="tech-content">
            <h3>Dolby Atmos - Klipsch</h3>
            <p>
              All three cinemas feature top-of-the-line international equipment and materials from
              the world’s most coveted manufacturers. All cinema layouts, acoustics, sounds, and
              visuals are designed, engineered, and calibrated entirely by Dolby Labs – meeting all
              standards and protocols.
            </p>
          </div>
          <div className="tech-logo">
            <img src="/assets/images/tech/logo-klipsch-dolby-7.1.png" alt="Dolby 7.1 – Klipsch" />
          </div>
          <div className="tech-content">
            <h3>Dolby 7.1 – Klipsch</h3>
            <p>
              Designed and made in the US, Klipsch was founded in 1946 by Paul W. Klipsch with the
              relentless aim of creating premium loudspeakers. Klipsch creates speakers that are
              highly efficient, accurate and have low distortion, with a wide dynamic range to
              recreate all kinds of sounds from the loudest to the softest, technology with accurate
              directivity to create the most lifelike sounds at the correct locations and recreate
              sounds as they are intended to be. Dolby 7.1 surround sound provides a four-zone sound
              experience, with a precise sound placement, enhanced audio definition and equally good
              sounds wherever you sit. Cinema’s 2 and 3 features a Dolby 7.1 surround sound system
              using __ Klipsch speakers and __ Klipsch subwoofers each.
            </p>
          </div>
          <div className="tech-logo">
            <img src="/assets/images/tech/logo-espedeo.png" alt="3D System – Espedeo" />
          </div>
          <div className="tech-content">
            <h3>3D System – Espedeo</h3>
            <p>
              Espedeo is a global digital cinema display equipment and solutions provider, offering
              a variety of premium products striking a balance between quality, simplicity, and
              innovation. All three cinemas feature an Espedeo 3D polarized system, projecting
              high-definition visuals with Hollywood studio reliability and quality. Glasses provide
              crisp and clear 3D images, in ultra-light weight comfortable frames, with options
              available for children and viewers wearing glasses.
            </p>
          </div>
          <div className="tech-logo">
            <img src="/assets/images/tech/logo-harkness.png" alt="Screens – Harkness" />
          </div>
          <div className="tech-content">
            <h3>Screens – Harkness</h3>
            <p>
              Harkness is the world’s leading screen technology provider. Originating in from the UK
              with over 90 years of experience and innovation. All three cinemas feature Harkness
              screens that have been optimized to fit the space best, using digital surveying,
              CAD/BIM design and simulations. Screens feature the most accurate image replications
              as the filmmaker intended, with deeper, richer visuals and impressive brightness and
              uniformity.
            </p>
          </div>
          <div className="tech-logo">
            <img src="/assets/images/tech/logo-barco-2k.png" alt="2K Laser Projectors – Barco" />
          </div>
          <div className="tech-content">
            <h3>2K Laser Projectors – Barco</h3>
            <p>
              Barco, founded in 1934 in Belgium, is a leading innovative digital projection and
              imaging technology company. Cinema 2 and 3 feature 2K smart laser phosphor projectors
              from Barco. These projectors boast a 30,000-hour constant brightness with consistent
              DCI-compliant Full HD image quality, 9500 lumens brightness, outstanding uniformity,
              and higher contrast. They both feature 3D capability.
            </p>
          </div>
          <div className="tech-logo">
            <img src="/assets/images/tech/logo-barco-4k.png" alt="4K Plasma Projector – Barco" />
          </div>
          <div className="tech-content">
            <h3>4K Plasma Projector – Barco</h3>
            <p>
              Belgian design and engineering. Cinema 1 features a Barco projector designed for
              larger screens with future-proof 4K image quality that is ultra-bright, razor sharp
              and vibrant in 2D and 3D both. This projector features a xenon plasma lamp creating up
              to 19,000 lumens comes and fitted with an advanced cooling system offering great
              reliability.
            </p>
          </div>
          <div className="tech-logo">
            <img
              src="/assets/images/tech/logo-heradesign.png"
              alt="Acoustics – Knauf AMF HERADESIGN®"
            />
          </div>
          <div className="tech-content">
            <h3>Acoustics – Knauf AMF HERADESIGN®</h3>
            <p>
              A cinema’s sound experience is only as good as it’s acoustic insulation. All three
              cinemas feature German-made Knauf wood wool acoustic panels. These innovative acoustic
              panels not only offer superior sound absorption but are also good for the planet. They
              are made of wood, water and magnesite making them have a neutral biological footprint.
              They are easily recyclable and biodegradable and can last up to 80 years – overall
              creating a product that is functional and sustainable! All our cinemas are
              acoustically designed and configured in Germany, there are no sharp 90-degree corners
              for the best acoustic performance, adding to an overall exceptional audio experience.
            </p>
          </div>
          <div className="tech-logo">
            <img src="/assets/images/tech/logo-camatic.png" alt="Seating - Camatic" />
          </div>
          <div className="tech-content">
            <h3>Seating - Camatic</h3>
            <p>
              All our cinema seating come from the land down under – Australia. Camatic are a world
              leading seating solutions provider for the past 55 years, with their products found
              all the way from the Sydney Opera House to Atlanta’s Olympic Stadium. Their portfolio
              of projects world over speaks of their seating quality, design, and comfort. All three
              cinemas feature retro red seating that is ergonomic, comfortable, and made to last.
              Cinema’s 1 and 3 feature the same seat model whereas Cinema 2 offers a slightly
              plusher and more premium seat. Seating layouts were designed locally and in
              consultation with Camatic, maximizing the best screen viewability without middle
              aisles and higher than standard seating elevations between rows. Easy access in and
              out of seats are created with two aisles on either side as well as above average leg
              room.
            </p>
          </div>
        </div>
      </div> */}
    </CinemaBlockStyled>
  );
};

export default CinemaLobby;
